/**
 * ImagearchiveController
 *
 * @author Marek Gabryjelski <marek.gabryjelski@pluswerk.ag>
 * @type {{Controller: {ImagearchiveController: Pluswerk.MesseImageArchive.Controller.ImagearchiveController}}}
 */
Pluswerk.MesseImageArchive = {
  Cache: {},
  Controller: {
    variables: {
      year: '',
      categories: '',
      assetCount: '',
      downloadLabel: '',
      pendingRequest: null,
      currentElement: null,
      cookieName: ''
    },
    ImagearchiveController: function () {
      var $imageArchive = $('.image_archive');
      if ($imageArchive.length > 0) {
        Pluswerk.MesseImageArchive.Controller.GetCategories($imageArchive);
      }
    },
    GetCategories: function ($imageArchive) {
        var $replaceContainer = $imageArchive.find('.js-imageArchiveContainer');
        var contentUid = $replaceContainer.attr('data-content-uid');
        var requestUri = encodeURI('?type=1690&contentUid=' + contentUid);
        Pluswerk.MesseImageArchive.Controller.variables.pendingRequest = $.ajax({
          url: requestUri,
            beforeSend: function () {
              $replaceContainer.html('<div class="spinner"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div></div><div class="spinner_text"><p></p></div>');
            },
            success: function (data) {
              $replaceContainer.html(data);
            },
            complete: function () {
              var $imagearchiveNavYears = $imageArchive.find('.image_archive__years');
              var $imagearchiveNavCategories = $imageArchive.find('.image_archive__categories');
              var $labels = $('.js-count-label');
              Pluswerk.MesseImageArchive.Controller.variables.pendingRequest = null;
              Pluswerk.MesseImageArchive.Controller.variables.assetCount = $labels.data('assetcount');
              Pluswerk.MesseImageArchive.Controller.variables.downloadLabel = $labels.data('download');
              if ($('.js-new-archive').length > 0) {
                Pluswerk.MesseImageArchive.Controller.RegisterNewEvents($imagearchiveNavYears, $imagearchiveNavCategories);
                Pluswerk.MesseImageArchive.Controller.ShowCorrectCategories($imagearchiveNavYears, $imagearchiveNavCategories);
              }
            }
        });
    },
    ShowCorrectCategories: function ($imagearchiveNavYears, $imagearchiveNavCategories) {
      var $tabs = $imagearchiveNavYears.find('.js-archive-tabs-anchor');
      if (!$tabs[0]) {
        var $currentYearButtons = $imagearchiveNavCategories.find('.js-archive-category-anchor');
        $currentYearButtons.removeClass('hide');
        $currentYearButtons[0].click();
      } else {
        $imagearchiveNavCategories.find('.js-archive-category-anchor').addClass('hide');
        var $currentYearButtons = $imagearchiveNavCategories.find(
          '.js-archive-category-anchor[data-year='
          + Pluswerk.MesseImageArchive.Controller.variables.year
          + ']'
        );
        $currentYearButtons.removeClass('hide');
        $currentYearButtons[0].click();
      }
    },
    RegisterNewEvents: function ($imagearchiveNavYears, $imagearchiveNavCategories) {
      var $tabs = $imagearchiveNavYears.find('.js-archive-tabs-anchor');
      var $categoryAnchorButtons = $($imagearchiveNavCategories).find('.js-archive-category-anchor');
      var $confirmButton = $('.js-confirm-usage');
      var $modal = $('.js-modal');
      var $downloadAgreedCheckbox = $('.js-download-agreed');

      Pluswerk.MesseImageArchive.Controller.variables.cookieName = $confirmButton.data('fair') + '_termsOfUsageAgreed';

      $tabs.on('click', function (e) {
        e.preventDefault();
        $tabs.parent().removeClass('r-tabs-state-active');
        $(this).parent().addClass('r-tabs-state-active');
        $tabs.attr('aria-expanded', false);
        Pluswerk.PlusProject.Utility.AccessibilityController.addTitleType($tabs, 'showTitle');
        Pluswerk.MesseImageArchive.Controller.variables.year = $(this).data('year');
        Pluswerk.MesseImageArchive.Controller.ShowCorrectCategories($imagearchiveNavYears, $imagearchiveNavCategories);
        Pluswerk.PlusProject.Utility.AccessibilityController.addAria($(this), 'aria-expanded');
        Pluswerk.PlusProject.Utility.AccessibilityController.addTitleType($(this), 'hideTitle');
      });

      $categoryAnchorButtons.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $categoryAnchorButtons.removeClass('button--active');
        $(this).addClass('button--active');

        Pluswerk.MesseImageArchive.Controller.variables.categories = $(this).data('categories');
        var assetCount = Pluswerk.MesseImageArchive.Controller.CalculateAssetCount($(this).data('assets'));
        Pluswerk.MesseImageArchive.Controller.GetAndReplaceNewArchives($('.image_archive'), assetCount);
      });

      $downloadAgreedCheckbox.on('change', function () {
        if (this.checked) {
          $confirmButton.prop('disabled', false);
        } else {
          $confirmButton.prop('disabled', true);
        }
      });

      $confirmButton.on('click', function () {
        var confirmation = $downloadAgreedCheckbox[0].checked;
        if (confirmation) {
          $.fancybox.close($modal);
          sessionStorage.setItem(Pluswerk.MesseImageArchive.Controller.variables.cookieName, 'true');
          if (Pluswerk.MesseImageArchive.Controller.variables.currentElement !== null) {
            Pluswerk.MesseImageArchive.Controller.variables.currentElement[0].click();
          }
        }
      });
      if ($tabs[0]) {
        $tabs[0].click();
      }
    },
    CalculateAssetCount: function (assetCountData) {
      var assetCount = 0;
      if (typeof assetCountData === 'number') {
        assetCount = assetCountData;
      } else {
        assetCountData = assetCountData.split(',');
        assetCountData.forEach(function (value) {
          assetCount += parseInt(value, 10);
        });
      }
      return assetCount;
    },
    GetAndReplaceNewArchives: function ($imagearchive, assetCount) {
      var $replaceContainer = $imagearchive.find('.list--image_archive');
      if (typeof Pluswerk.MesseImageArchive.Cache[Pluswerk.MesseImageArchive.Controller.variables.categories] !== 'undefined') {
        $replaceContainer.html(Pluswerk.MesseImageArchive.Cache[Pluswerk.MesseImageArchive.Controller.variables.categories]);
      } else {
        Pluswerk.MesseImageArchive.Controller.FetchArchive($replaceContainer, assetCount);
      }
    },
    FetchArchive: function ($replaceContainer, assetCount) {
      var pageUid = $replaceContainer.attr('data-pageUid');
      var requestUri = encodeURI('?type=1689&categories=' + Pluswerk.MesseImageArchive.Controller.variables.categories + '&pageUid=' + pageUid);
      if (Pluswerk.MesseImageArchive.Controller.variables.pendingRequest !== null) {
        Pluswerk.MesseImageArchive.Controller.variables.pendingRequest.abort();
      }
      Pluswerk.MesseImageArchive.Controller.variables.pendingRequest = $.ajax({
        url: requestUri,
        beforeSend: function () {
          $replaceContainer.html('<div class="spinner"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div></div><div class="spinner_text"><p>'
            + assetCount
            + ' '
            + Pluswerk.MesseImageArchive.Controller.variables.assetCount
            + '</p></div>');
        },
        success: function (data) {
          if (Pluswerk.MesseImageArchive.Controller.ValidateResponseData(data)) {
            Pluswerk.MesseImageArchive.Cache[Pluswerk.MesseImageArchive.Controller.variables.categories] = data;
            $replaceContainer.html(data);
          }
        },
        complete: function () {
          Pluswerk.MesseImageArchive.Controller.variables.pendingRequest = null;
          Pluswerk.MesseImageArchive.Controller.InitTermsOfUseModal();
        }
      });
    },
    InitTermsOfUseModal: function() {
      var $modal = $('.js-modal');
      $('.js-archive-download').on('click', function (e) {
        if (sessionStorage.getItem(Pluswerk.MesseImageArchive.Controller.variables.cookieName) !== 'true') {
          e.preventDefault();
          Pluswerk.MesseImageArchive.Controller.variables.currentElement = $(this);
          $.fancybox.open($modal, {
            type: 'html',
            baseClass: 'imagearchive-fancybox',
            afterClose: function() {
              $('.js-download-agreed').prop('checked', false);
              $('.js-confirm-usage').prop('disabled', true);
            },
          });
        } else {
          $modal.html('<div class="spinner"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div></div><div class="spinner_text"><p>' +
            Pluswerk.MesseImageArchive.Controller.variables.downloadLabel + '</p></div>');
          $.fancybox.open($modal, {
            type: 'html'
          });
          var cookieCheck = setInterval(cookieFinder, 1000);
        }
      });
    },
    ValidateResponseData: function (data) {
      var assetsOfActiveButton = Pluswerk.MesseImageArchive.Controller.CalculateAssetCount(
        $('.js-archive-category-anchor.button--active').data('assets')
      );
      var responseCount = (data.match(/js-li-count/g) || []).length;
      return responseCount === assetsOfActiveButton;
    }
  }
};

function cookieFinder() {
  var cookies = document.cookie;
  if (cookies.search('fileDownload')>0) {
    var $modal = $('.js-modal');
    var cookieName = 'fileDownload';
    var cookie = getCookie(cookieName);
    if(cookie) {
      $.fancybox.close($modal);
      document.cookie = cookieName + "=; expires=" + Date.now() + "; path=/;";
    }
  }
}

function getCookie(name) {
  var cookieName = name + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ck = decodedCookie.split(';');
  for (var i =0; i<ck.length; i++) {
    var cookie = ck[i];
    while (cookie.charAt(0) === ' ') {
      cookie =  cookie.substring(1);
    }
    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
   return '';
}
